import React from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";

function PageControl(props) {
  let control;
  switch (props.page) {
    case 0:
      control = (
        <div className="side-panel-actions">
          <Col>
            <Button variant="primary" disabled>
              Vorige
          </Button>
            <Button variant="primary" onClick={props.nextPage}>
              Volgende
          </Button>
          </Col>
        </div>
      );
      break;
    case 5://6:
      control = (
        <div className="side-panel-actions">
          <Col>

            <Button variant="primary" onClick={props.prevPage}>
              Vorige
          </Button>
            <Button variant="primary" onClick={() => props.handleOrderPopup(true)}>
              Bestellen
          </Button>
          </Col>
        </div>
      );
      break;
    default:
      control = (
        <div className="side-panel-actions">
          <Col>
            <Button variant="primary" onClick={props.prevPage}>
              Vorige
          </Button>
            <Button variant="primary" onClick={props.nextPage}>
              Volgende
          </Button>
          </Col>
        </div>
      );
  }

  return control;
}

export default PageControl;
